import { useTranslation } from 'react-i18next'

import { LegalDocumentType } from '@/Shared/domain'
import { useDownloaderHook } from '@/Shared/ui/downloader'
import { NavbarUserListItemModel } from '@/Shared/ui/navigation'
import { navigationTranslation } from '@/Shared/ui/navigation/navigationTranslation'
import { navigationRoutes } from '@/Shared/ui/routers'

interface NavigationState {
  navbarUserMenu: NavbarUserListItemModel[]
}

export const useHeaderNavigationData = (): NavigationState => {
  const { downloadLegalDocument } = useDownloaderHook()
  const { t } = useTranslation()

  const navbarUserMenu: NavbarUserListItemModel[] = [
    {
      title: t(navigationTranslation.header.user.configuration),
      link: navigationRoutes.configuration,
    },
    {
      title: t(navigationTranslation.header.user.access),
      link: navigationRoutes.accessRoles,
    },
    {
      title: t(navigationTranslation.header.user.usageConditions),
      divider: true,
      size: 'text-xs',
      handleClick: () =>
        downloadLegalDocument(
          LegalDocumentType.useWebConditions,
          t(navigationTranslation.header.user.usageConditions),
        ),
    },
    {
      title: t(navigationTranslation.header.user.legal),
      size: 'text-xs',
      handleClick: () =>
        downloadLegalDocument(
          LegalDocumentType.legalAdvice,
          t(navigationTranslation.header.user.legal),
        ),
    },
    {
      title: t(navigationTranslation.header.user.privacyPolicy),
      size: 'text-xs',
      handleClick: () =>
        downloadLegalDocument(
          LegalDocumentType.privacyPolicies,
          t(navigationTranslation.header.user.privacyPolicy),
        ),
    },
    {
      title: t(navigationTranslation.header.user.cookiesPolicy),
      size: 'text-xs',
      handleClick: () =>
        downloadLegalDocument(
          LegalDocumentType.cookiesPolicies,
          t(navigationTranslation.header.user.cookiesPolicy),
        ),
    },
  ]

  return { navbarUserMenu }
}
